import { useState, useEffect } from 'react';
import { agentsApi, Agent } from '../services/agentsApi';

export function useAgents() {
  const [agents, setAgents] = useState<Agent[]>([]);
  const [loading, setLoading] = useState(true);

  const loadAgents = async () => {
    try {
      setLoading(true);
      console.log('[useAgents] 🔄 Cargando agentes desde tabla agents...');
      
      const data = await agentsApi.listAgents();
      
      console.log('[useAgents] ✅ Agentes cargados:', data.length);
      console.log('[useAgents] 📋 Agentes:', data.map(a => ({ 
        id: a.id, 
        nombre: a.nombre, 
        active_workflow_id: a.active_workflow_id 
      })));
      
      setAgents(data);
    } catch (error) {
      console.error('[useAgents] ❌ Error cargando agentes:', error);
      setAgents([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAgents();
  }, []);

  return {
    agents,
    loading,
    reload: loadAgents,
  };
}
